import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import useDocTitle from '../utils/useDocTitle';
import { useLanguage } from '../context/LanguageContext';
import Notiflix from 'notiflix';

const Contact = () => {
    const { language } = useLanguage(); // Access the language context
    useDocTitle(language === 'English' ? 'Contact Us' : 'Na Kontaktoni');

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState([]);

    const clearErrors = () => setErrors([]);

    const clearInput = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setMessage('');
    };

    const sendEmail = (e) => {
        e.preventDefault();
        Notiflix.Report.success(
            '',
            language === 'English' ? 'Thank you for reaching out to us!' : 'Faleminderit që po na kontaktoni!',
            language === 'English' ? 'Okay' : 'Në rregull'
        );
    };

    return (
        <>
            <NavBar />
            <main id='contact' className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24" aria-labelledby="contact-header">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
                    <form onSubmit={sendEmail} aria-label={language === 'English' ? 'Contact form' : 'Formular kontakti'}>
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <h1 id="contact-header" className="font-bold text-center lg:text-left text-primary uppercase text-4xl">
                                {language === 'English' ? 'Contact Us' : 'Na Kontaktoni'}
                            </h1>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                {/* Accessible Input Fields */}
                                <div>
                                    <label htmlFor="first-name" className="sr-only">
                                        {language === 'English' ? 'First Name' : 'Emri'}
                                    </label>
                                    <input
                                        id="first-name"
                                        name="first_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder={language === 'English' ? 'First Name*' : 'Emri*'}
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        aria-required="true"
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.first_name}</p>}
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="sr-only">
                                        {language === 'English' ? 'Last Name' : 'Mbiemri'}
                                    </label>
                                    <input
                                        id="last-name"
                                        name="last_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder={language === 'English' ? 'Last Name*' : 'Mbiemri*'}
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        aria-required="true"
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.last_name}</p>}
                                </div>
                                <div>
                                    <label htmlFor="email" className="sr-only">
                                        {language === 'English' ? 'Email' : 'Email'}
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="email"
                                        placeholder={language === 'English' ? 'Email*' : 'Email*'}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={clearErrors}
                                        aria-required="true"
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.email}</p>}
                                </div>
                                <div>
                                    <label htmlFor="phone" className="sr-only">
                                        {language === 'English' ? 'Phone' : 'Telefoni'}
                                    </label>
                                    <input
                                        id="phone"
                                        name="phone_number"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="number"
                                        placeholder={language === 'English' ? 'Phone*' : 'Telefoni*'}
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        onKeyUp={clearErrors}
                                        aria-required="true"
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.phone_number}</p>}
                                </div>
                            </div>
                            <div className="my-4">
                                <label htmlFor="message" className="sr-only">
                                    {language === 'English' ? 'Message' : 'Mesazhi'}
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder={language === 'English' ? 'Message*' : 'Mesazhi*'}
                                    className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onKeyUp={clearErrors}
                                    aria-required="true"
                                ></textarea>
                                {errors && <p className="text-red-500 text-sm">{errors.message}</p>}
                            </div>
                            <div className="my-2 w-1/2 lg:w-2/4">
                                <button
                                    type="submit"
                                    id="submitBtn"
                                    className="uppercase text-sm font-bold tracking-wide bg-primary hover:bg-primary-dark text-white p-3 rounded-lg w-full 
                                        focus:outline-none focus:shadow-outline"
                                >
                                    {language === 'English' ? 'Send Message' : 'Dërgo Mesazhin'}
                                </button>
                            </div>
                        </div>
                    </form>
                    <aside className="w-full lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-primary rounded-2xl text-white">
                        <h2 className="text-2xl font-black">
                            {language === 'English' ? 'Office Address' : 'Adresa e Zyrës'}
                        </h2>
                        <address className="text-medium font-extrabold">
                            {language === 'English'
                                ? 'Myslym Shyri Street, Domus Building, 4th Floor, Apt.7, 1001 Tirana'
                                : 'Rruga Myslym Shyri, Pallati Domus, Kati 4 Ap.7, 1001 Tiranë, Shqipëri'}
                        </address>
                        <h2 className="text-2xl font-black mt-5">
                            {language === 'English' ? 'Call Us' : 'Na Telefononi'}
                        </h2>
                        <p className="text-medium font-extrabold">Tel: +355 69 368 0044</p>
                        <h2 className="text-2xl font-black mt-5">
                            {language === 'English' ? 'Send an E-mail' : 'Na Dërgoni një E-mail'}
                        </h2>
                        <p className="text-medium font-extrabold">annexpilot1@gmail.com</p>
                    </aside>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Contact;